module.exports = __webpack_public_path__ + "static/media/post10.7ee8fddd.PNG";